module.exports = __webpack_public_path__ + "media/application/images/practitioner-bg-2659b1400a18217db6cbd375b074247b.webp";